import { useTranslation as useTranslationI18N } from 'react-i18next';
import type { TOptions } from 'i18next';

import type { DictionaryData } from './types';

import { SOURCE_DICTIONARY_KEY_FOR_WEBLATE_KEY } from '../../../bin/translations/constants';
import { getSupportedLang } from '../utils/supported-lang-functions';
import getDefaultValue from './get-default-value';

// ---

export type tFunction = (dictionaryData: DictionaryData, options?: TOptions) => string;

export const useTranslation = (...props: Parameters<typeof useTranslationI18N>) => {
  const { t: i18T, i18n, ...rest } = useTranslationI18N(...props);

  const t: tFunction = (dictionaryData, options) => {
    if (!dictionaryData) {
      console.warn('useTranslation -> dictionaryData не найден. Будет отображаться текст заглушка.');
      return '--';
    }

    const key = SOURCE_DICTIONARY_KEY_FOR_WEBLATE_KEY;

    return i18T(
      dictionaryData[key],
      getDefaultValue(dictionaryData),
      options,
    );
  };

  return {
    ...rest,
    lang: getSupportedLang(i18n.language),
    t,
  };
};
